import 'react-select-v1/dist/react-select.css';
import React from 'react';
import AgentProposalItem from './AgentProposalItem.js';
import CaseCreationItem from './CaseCreationItem.js';
import CaseStatusItem from './CaseStatusItem.js';
import ConnectUpdateItem from './ConnectUpdateItem.js';
import DocumentItem from './DocumentItem.js';
import EconomyItem from './EconomyItem.js';
import InteractionItem from './InteractionItem.js';
import { HistItemType } from './itemTypes.js';
import PaymentPlanItem from './PaymentPlanItem.js';
import TribunalCaseItem from './TribunalCaseItem.js';
import UpdateItem from './UpdateItem.js';
const HistItemTypes = (props) => {
    const { historyItem, singleCase } = props;
    switch (historyItem.type) {
        case HistItemType.PaymentPlan:
            return React.createElement(PaymentPlanItem, { ...historyItem });
        case HistItemType.TribunalCase:
            return React.createElement(TribunalCaseItem, { ...historyItem });
        case HistItemType.Document:
            return React.createElement(DocumentItem, { ...historyItem });
        case HistItemType.AgentProposal:
            return React.createElement(AgentProposalItem, { ...historyItem });
        case HistItemType.Updates:
            return React.createElement(UpdateItem, { historyItem: historyItem, singleCase: singleCase });
        case HistItemType.VoucherCollection:
            return singleCase ? (React.createElement(EconomyItem, { historyItem: historyItem, caseId: singleCase.caseId })) : null;
        case HistItemType.Interactions:
            return (React.createElement(InteractionItem, { historyItem: historyItem, referenceId: props.referenceId, referenceType: props.referenceType }));
        case HistItemType.CaseCreation:
            return React.createElement(CaseCreationItem, { ...historyItem });
        case HistItemType.CaseStatus:
            return React.createElement(CaseStatusItem, { ...historyItem });
        case HistItemType.ConnectUpdate:
            return React.createElement(ConnectUpdateItem, { historyItem: historyItem });
        default:
            return null;
    }
};
export default HistItemTypes;
//# sourceMappingURL=HistItemTypes.js.map